import { Button, Form, Input, InputNumber } from 'antd';
import { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { UserContext } from '../Context/UserContext';
import { useHistory, useParams } from 'react-router-dom';

const MoviesForm = () => {
    const [movieEdit, setMovieEdit] = useState({
        title: "",
        description: "",
        year: "",
        duration: "",
        genre: "",
        rating: "",
        review: "",
        image_url: ""
    })
    const [user] = useContext(UserContext)
    const [ready, setReady] = useState(false)
    const history = useHistory()
    let {id} = useParams()
    console.log(id)

    useEffect(() => {
        if (!id){
            setReady(true)
        } else {
            const userEdit = async () => {
                await axios.get(`https://super-bootcamp-backend.sanbersy.com/api/movies/${id}`, {headers: {"Authorization" : "Bearer "+ user.token}})
                    .then((res) => {
                        setMovieEdit (res.data)
                        setReady(true)
                    }).catch((err) => {
                        console.log(err)
                    })
            } 
            userEdit()
        }  
    },[id, user.token])


    const onFinish = (values) => {
        if(!id) {
            // values.year = String(values.year)
            // values.rating = String(values.rating)
            // values.duration = String(values.duration)
            axios.post("https://super-bootcamp-backend.sanbersy.com/api/movies", values, {headers: {"Authorization" : "Bearer "+ user.token}})
                .then(() => {
                    // message.success('Data added successfully!')
                    history.push("/table-movies")
                })
        } else {
            // values.year = String(values.year)
            // values.rating = String(values.rating)
            // values.duration = String(values.duration)
            axios.put(`https://super-bootcamp-backend.sanbersy.com/api/movies/${id}`, values, {headers: {"Authorization" : "Bearer "+ user.token}})
                .then(() => {
                    // message.success('Data edited successfully!')
                    history.push("/table-movies")
                })
        }
        
    }

    // const onFinishFailed = (errorInfo) => {
    // console.log('Failed:', errorInfo);
    // };

    const HandleCancel = () => {
        history.push("/table-movies")
    }
        
    return(
        ready && 
        <Form
        labelCol={{
          span: 4,
        }}
        wrapperCol={{
          span: 14,
        }}
        layout="horizontal"
        name="movies-form"
        onFinish={onFinish}
        autoComplete="off"
        initialValues={{
            title: movieEdit.title,
            description: movieEdit.description,
            year: movieEdit.year,
            duration: movieEdit.duration,
            genre: movieEdit.genre,
            rating: movieEdit.rating,
            review: movieEdit.review,
            image_url: movieEdit.image_url
        }}
      >
        <Form.Item label="Title" name="title" rules={[
                    {
                        required: true,
                        message: "Please input the title!"
                    }
                ]
                }   >
          <Input value="inputTitle" />
        </Form.Item>
        <Form.Item label="Description" name="description" rules={[
                    {
                        required: true,
                        message: "Please input the description!"
                    }
                ]
                }>
          <Input value="inputDescription" />
        </Form.Item>
        <Form.Item 
            label="Year"
            name="year"
            rules={[
                {
                    required: true,
                    message: "Please input the year!"
                }
            ]
            }>
          <InputNumber value="inputYear" min={1900} />
        </Form.Item>
        <Form.Item 
            label="Duration"
            name="duration" 
            rules={[
                {
                    required: true,
                    message: "Please input the duration!"
                }
            ]
            }>
          <InputNumber value="inputDuration" min={15} /> 
        </Form.Item>
        <Form.Item label="Genre" name="genre" rules={[
                    {
                        required: true,
                        message: "Please input the genre!"
                    }
                ]
                }>
          <Input value="inputGenre" />
        </Form.Item>
        <Form.Item 
            label="Rating"
            name="rating"
            rules={[
                {
                    required: true,
                    message: "Please input the rating!"
                }
            ]
            }>
          <InputNumber value="inputRating" min={0} max={10} /> 
        </Form.Item>
        <Form.Item label="Review" name="review" rules={[
                    {
                        required: true,
                        message: "Please input the review!"
                    }
                ]
                }>
          <Input value="inputReview" />
        </Form.Item>
        <Form.Item label="Image URL" name="image_url" rules={[
                    {
                        required: true,
                        message: "Please input the image url!"
                    }
                ]
                }>
          <Input value="inputImage" />
        </Form.Item>
        <Form.Item
                wrapperCol={{
                offset: 8,
                span: 16,
                }}
            >
                <Button type="primary" htmlType="submit">
                Submit
                </Button>
                <Button type="danger" onClick={HandleCancel} style={{marginLeft: "20px"}}>
                Cancel
                </Button>
            </Form.Item>
      </Form>
    )
}

export default MoviesForm